import TrafficSimulation from 'src/pages/TrafficSimulation'

const TrafficSimulationRoute = () => {
  return <TrafficSimulation />
}

export default TrafficSimulationRoute
